import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import {
  faArrowCircleLeft,
  faArrowCircleRight,
} from "@fortawesome/pro-solid-svg-icons";
import { Store } from "@ngrx/store";
import { AppService } from "src/app/app.service";
import { GetSourceMetaParams } from "src/app/store/models/right-panel-models";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { SurprisePageDataService } from "../surprise-page-data.service";
import { Subscription } from "rxjs";
import { SetSourceMetaGridFilters } from "src/app/store/actions/right-panel-actions";

@Component({
  selector: "app-surprise-page",
  templateUrl: "./surprise-page.component.html",
  styleUrls: ["./surprise-page.component.scss"],
  host: { class: "surprise-page-component" },
  encapsulation: ViewEncapsulation.None,
})
export class SurprisePageComponent implements OnInit, OnDestroy {
  surpriseMeta: any = {
    filters: {
      percentChange: "default",
      filterLineItem: "",
    },
  };

  gridFilters = {
    surprise: "default",
    filterLineItem: "",
    cut_expansions: [],
    onlySurprise: false,
    period_list: [],
  };

  disabledSidebar = false;
  isRightsideBarCollapsed = true;
  showRightSidebar = true;
  faArrowCircleLeft = faArrowCircleLeft;
  faArrowCircleRight = faArrowCircleRight;
  ticker = "";
  tickerFullName = "";
  vaActualsInfoModalVisible = false;
  metaSubscriber: Subscription;
  pageParamsSubcription: Subscription;
  rightPanelLoaded: Subscription;
  constructor(
    private dataService: SurprisePageDataService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private titleService: Title,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.pageParamsSubcription = this.store
      .select(stateGetter("navigationSettings", "pageParams", "ticker"))
      .subscribe((ticker: string) => {
        if (ticker) {
          this.ticker = ticker;
          this.getSurpriseMeta();
        }
      });

    this.metaSubscriber = this.store
      .select(stateGetter("rightPanel", "sourceMeta"))
      .subscribe((data: GetSourceMetaParams) => {
        const ticker = data.ticker;
        if (ticker !== undefined) {
          this.getSurpriseMeta();
        }
      });

    this.store.select(stateGetter("globalSubheader")).subscribe((resp) => {
      this.tickerFullName = resp.subheaderTitle;
    });

    //set page title
    this.route.params.subscribe((params) => {
      this.titleService.setTitle(
        `Surprise Analysis - ${params.ticker.toUpperCase()}`,
      );
    });

    this.logUserAction();
  }

  ngOnDestroy() {
    if (this.metaSubscriber) {
      this.metaSubscriber.unsubscribe();
    }
    if (this.pageParamsSubcription) {
      this.pageParamsSubcription.unsubscribe();
    }
  }

  getSurpriseMeta() {
    this.dataService.getSurpriseMeta(this.ticker).subscribe((response) => {
      if (this.rightPanelLoaded) {
        this.rightPanelLoaded.unsubscribe();
      }

      this.rightPanelLoaded = this.store
        .select(stateGetter("rightPanel", "sourceMeta", "loaded"))
        .subscribe((loaded: boolean) => {
          if (!loaded) {
            return;
          }

          const surpriseMeta = response;

          //setting default filters
          this.surpriseMeta = surpriseMeta;
          this.surpriseMeta.tickerFullName = this.tickerFullName;
          this.surpriseMeta.ticker = this.ticker;

          this.gridFilters = JSON.parse(
            JSON.stringify(this.surpriseMeta.filters),
          );
          if (
            !this.surpriseMeta.filters.cut_expansions ||
            this.surpriseMeta.filters.cut_expansions.length === 0
          ) {
            this.surpriseMeta.filters.cut_expansions = [
              this.surpriseMeta.tabs[0].name,
            ];
            this.gridFilters.cut_expansions = [this.surpriseMeta.tabs[0].name];
          } else {
            this.gridFilters.cut_expansions =
              this.surpriseMeta.filters.cut_expansions;
          }
          this.gridFilters.surprise = this.gridFilters.surprise || "default";
          this.gridFilters.onlySurprise =
            this.gridFilters.onlySurprise || false;
          this.gridFilters.filterLineItem =
            this.gridFilters.filterLineItem || "";
          this.gridFilters.period_list =
            this.gridFilters.period_list || this.surpriseMeta.periods;
        });
    });
  }

  onClearLineitemSearch(surpriseGrid) {
    this.gridFilters.filterLineItem = "";
    surpriseGrid.onFilterChange(["lineitem"]);
  }

  onFilterChange(isSwitchOn: boolean, property: string) {
    this.gridFilters[property] = isSwitchOn;
    this.gridFilters = Object.assign({}, this.gridFilters);

    // true -> Don;t set clear Flag
    // false -> set clear Flag
    const diffInFilter = this.appService.compare(
      this.surpriseMeta.filters,
      this.gridFilters,
    );
    this.store.dispatch(new SetSourceMetaGridFilters(!diffInFilter));

    this.appService.logUserAction(
      {},
      this.ticker,
      null,
      "Show only surprise",
      { beginning_state_referrer: "Surprise Analysis Page" },
      "",
      "Surprise Toggle click",
    );

    const jsonData = { filters: this.gridFilters };
    this.dataService.saveUserFilters(jsonData, this.ticker).subscribe();
  }

  logUserAction() {
    const today = new Date();
    const currentTime = today.toUTCString();
    const currentURL = window.location.href;
    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      "Surprise Analysis Page",
      {
        PAGE: "Surprise Analysis Page",
        UTCTIME: currentTime,
        URL: currentURL,
        VALUE: this.ticker,
        beginning_state_referrer: "Company page",
      },
      "",
      "Left panel click",
    );
  }

  rightSiderCollapseChanged(isCollapsed) {
    this.logRpExpansionState(isCollapsed);
  }

  openVaActualCalculationInfo(shouldOpen: boolean) {
    this.vaActualsInfoModalVisible = shouldOpen;
  }

  logRpExpansionState(isCollapsed) {
    this.appService.logUserAction(
      `RIGHT_PANEL_${isCollapsed ? "COLLAPSE" : "EXPAND"}`,
      this.ticker,
      "",
      `RIGHT_PANEL_${isCollapsed ? "COLLAPSE" : "EXPAND"}`,
      {
        company: this.ticker,
      },
      "",
      "RIGHT_PANEL_CLICK",
    );
  }
}
